module.exports = __webpack_public_path__ + "img/amazoneks-black.a84e95fa.svg";